import { api } from "@/services/api"

export const requestLogInLink = async (params: {
  email: string
}) => {
  const { body } = await api.post(
    "/beepaidgo/request-login-link-session/",
    {
      body: params,
    }
  )
  return body
}
